import type { TemplateFormLanguage } from '../types/templateForms';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';

export interface VerifyEmailTranslations {
    title: (formType: 'intake' | 'draft') => string;
    emailLabel: string;
    fieldRequired: string;
    verifying: string;
    verify: string;
}

const ENGLISH_TRANSLATIONS: VerifyEmailTranslations = {
    title: (formType) => `Enter your email to access the ${formType} form`,
    emailLabel: 'Email',
    fieldRequired: 'This field is required',
    verifying: 'Verifying...',
    verify: 'Verify',
};

const FRENCH_TRANSLATIONS: VerifyEmailTranslations = {
    title: (formType) =>
        formType === 'intake'
            ? 'Entrez votre courriel pour accéder au formulaire d’admission'
            : 'Entrez votre courriel pour accéder au brouillon du formulaire',
    emailLabel: 'Courriel',
    fieldRequired: 'Ce champ est obligatoire',
    verifying: 'Vérification en cours...',
    verify: 'Vérifier',
};

export const VERIFY_EMAIL_TRANSLATIONS: Record<TemplateFormLanguage, VerifyEmailTranslations> = {
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
};

export function getVerifyEmailTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): VerifyEmailTranslations {
    return VERIFY_EMAIL_TRANSLATIONS[language] ?? VERIFY_EMAIL_TRANSLATIONS.en;
}
